import { API, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import ToolDocumentForm from "components/tools/documents/ToolDocumentForm";
import { createToolDocument } from "graphql/mutations";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const ToolDocumentCreateForm = ({ toolID, onSuccess }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const toolDocument = {
    fileName: "",
    fileSrc: "",
  };

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = "";

      if (fileObj) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`tools/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });
      }

      await API.graphql({
        query: createToolDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            toolID,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/tools");
    } catch (err) {
      console.log("Error Tool Document creation", err);
      toast.error(strings.responses.unexpectedError);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <ToolDocumentForm
        onSubmit={onSubmit}
        initialValues={toolDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Documento de Herramienta",
    successAdded: "Documento de Herramienta agregado con éxito",
    responses: {
      unexpectedError: "Error inesperado en la creación",
    },
  },
});

export default ToolDocumentCreateForm;
